import React, { useCallback, useMemo, useContext } from 'react';
import { useQuery } from 'react-query';
import { Form, FormSpy } from 'react-final-form';
import moment from 'moment';

import { getUser, updateUser } from 'api/login';
import SubmitBtn from 'components/Form/SubmitBtn';
import ProfileEditForm from './ProfileEditForm';
import { NotificationAlertsContext, ALERT_TYPES } from 'components/NotificationAlerts';

/**
 * campos
 * first_name
 * last_name
 * user_name
 * email
 * date_of_birth
 * gender
 * role
 * country
 * sports
 */

const buildUser = (values, data) => {
  return {
    ...data,
    ...values,
  };
};

const ProfileEdit = () => {
  const { createAlert } = useContext(NotificationAlertsContext);

  const resolver = useCallback(async (key, _eventId) => {
    const { body } = await getUser();

    return body?.data?.user || null;
  }, []);

  const { data, status, refetch } = useQuery('get-user', resolver);
  const initialValues = useMemo(
    () => ({
      ...data,
      date_of_birth: moment(data?.date_of_birth).toDate(),
    }),
    [data],
  );

  const onSubmit = useCallback(
    values => {
      return new Promise(async resolve => {
        try {
          const { status } = await updateUser(data?.id, buildUser(values, data));

          if (status === 201) {
            resolve({});
            createAlert('Guardado con éxito.');
            refetch();
          } else {
            resolve({ req: 'error' });
            createAlert(
              'No se puede realizar esta acción. Porfavor intenta nuevamente.',
              ALERT_TYPES.ERROR,
            );
          }
          return;
        } catch (_) {
          console.log(_);
          resolve({ req: 'error' });
          createAlert(
            'No se puede realizar esta acción. Porfavor intenta nuevamente.',
            ALERT_TYPES.ERROR,
          );
          return;
        }
      });
    },
    [createAlert, data, refetch],
  );

  return (
    <div className="rounded-lg bg-white mb-6 p-4 shadow-sm min-h-screen">
      <div className="flex flex-wrap h-full">
        <div className="w-full md:w-2/3 mb-6 md:mb-0 md:pr-6 md:mt-2">
          {status !== 'loading' && (
            <Form
              initialValues={initialValues}
              onSubmit={onSubmit}
              subscription={{}}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div className="border-b mb-4 pb-2">
                    <FormSpy
                      subscription={{ submitting: true }}
                      render={({ submitting }) => (
                        <SubmitBtn
                          disabled={submitting}
                          loading={submitting}
                          onClick={handleSubmit}
                        >
                          Guardar
                        </SubmitBtn>
                      )}
                    />
                  </div>
                  <ProfileEditForm profile={data} />
                </form>
              )}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileEdit;
